<template>
    <div class="saas-feature section-space--ptb_90 bg-gray">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center section-space--mb_60">
                        <h2 class="font-weight--light mb-15 wow move-up">{{ $t("home.offer") }}</h2>
                        <span class="section-text wow move-up">{{ $t("home.offer_text") }}</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div v-for="item in items" :key="item.id" class="col-lg-4 col-md-6 wow move-up">
                    <div class="service-grid">
                        <div class="ht-service-box--one style-03">
                            <a :href="item.link">
                                <div class="image__media">
                                    <img :src="item.icon" class="img-fluid" alt="aeroland-app-showcase-box-icon-image-01">
                                </div>
                                <div class="content">
                                    <h6 class="heading">{{ $t(item.heading) }}</h6>
                                    <div class="service_text">{{ $t(item.text) }}</div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FeatureHome',
        data (){
            return {
                items: [
                    {
                        icon: require('../assets/img/trustami/langdetect.png'),
                        heading: "home.lang",
                        text: "home.lang_text",
                        link: 'language-detection'
                    },
                    {
                        icon: require('../assets/img/trustami/sentiment.png'),
                        heading: "home.sent",
                        text: "home.sent_text",
                        link: 'sentiment'
                    },
                    {
                        icon: require('../assets/img/trustami/summarization.png'),
                        heading: "home.summ",
                        text: "home.summ_text",
                        link: 'text-summarization'
                    },
                    {
                        icon: require('../assets/img/trustami/tokenizer.png'),
                        heading: "home.tokn",
                        text: "home.tokn_text",
                        link: 'tokenizer'
                    },
                    {
                        icon: require('../assets/img/trustami/ner_tagger.png'),
                        heading: "home.nert",
                        text: "home.nert_text",
                        link: 'entity-recognition'
                    },
                    {
                        icon: require('../assets/img/trustami/keywords.png'),
                        heading: "home.keyw",
                        text: "home.keyw_text",
                        link: 'keywords'
                    }
                ]
            }
        }
    }
</script>
